// v-resize.immediate
// v-resize
import { throttle } from 'lodash'

const vResize = {
  bind(el, {value, modifiers}) {
      if (!isFunction(value)) {
          throw new Error(`${value} must be a function`)
      }

      if (supportResizeObserver()) {
          createObserver(modifiers, el, value)
          return
      }
      el.style.position = 'relative'
      el.appendChild(createIframe())
  },
  unbind (el) {
    el.__resize_observer__ && el.__resize_observer__.disconnect()
    el.__resize_observer__ = null
  }
}

const createIframe = () => {
  const iframe = document.createElement('iframe')
  iframe.style.border = 'none'
  iframe.style.zIndex = -99
  iframe.style.position = 'absolute'
  iframe.style.top = 0
  iframe.style.bottom = 0
  iframe.style.left = 0
  iframe.style.right = 0
  iframe.style.width = '100%'
  iframe.style.height = '100%'
  setTimeout(() => {
      const {contentWindow} = iframe
      const {modifiers, el, value} = vResize
      modifiers.immediate && emitElementSize(el, value)
      contentWindow.addEventListener('resize', function () {
          emitElementSize()
      })
  })

  return iframe
}
const createObserver = (modifiers, el, value) => {
  let first = true
  const observer = new ResizeObserver(() => {
      if (first) {
          first = false
          if (!modifiers.immediate) {
              return
          }
      }
      emitElementSize(el, value)
  })
  observer.observe(el)
  el.__resize_observer__ = observer
}
const emitElementSize = throttle((el, value) => {
  const {scrollWidth, scrollHeight} = el
  value({
      width: scrollWidth,
      height: scrollHeight
  })
}, 300)

const supportResizeObserver = () => {
  return window.ResizeObserver && isFunction(window.ResizeObserver)
}

const isFunction = v => Object.prototype.toString.call(v) === '[object Function]'

export default vResize



// WEBPACK FOOTER //
// ./src/public/directives/resize.js